/* remates-1-2-1 (#458) -- QUIEN LE COBRA EL PRO AL USUARIO, HOY.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los archivos nuevos).

   `/auth/me` y `/auth/login` mandan `billing_source`: la suscripcion VIVA hoy (Stripe
   viva gana; Apple solo con su caducidad en el futuro; `null` si no hay nada vivo).
   `billing_provider` es el RASTRO de la ultima compra y puede mentir: una cuenta que
   paga por Stripe y alguna vez compro en Apple lo lleva en "apple".

   LA CAIDA: si el campo NO VIENE (backend viejo, ventana de despliegue), manda
   `billing_provider`, o sea la pantalla de antes. Si viene y dice `null`, es `null`:
   el servidor ya dijo que no hay nada vivo y el rastro no lo desmiente.

   Lo leen Ajustes, la ventana de borrar la cuenta y la pantalla de precios. */
export function fuenteDePro(user) {
  if (!user) return undefined;
  return Object.prototype.hasOwnProperty.call(user, 'billing_source')
    ? user.billing_source
    : user.billing_provider;
}

export default fuenteDePro;
